<template>
  <div class="app-main-inner app-main-page-tab queryWriteOff">
    <write-off-search
      ref="searchItem"
      :is-append-query="true"
      :custom-sim-query-placeholder="simQueryPlaceholder"
      config-module="509"
      grid-config-module="190706"
      :ar="ar"
      :is-bank-slip="0"
      :oversea="oversea"
      :verf-date="verfDate"
      :pre-query="preQuery"
      :input-date-start="searchConditions.startDate"
      :input-date-end="searchConditions.endDate"
      :show-controlled-charge="false"
      :show-bill-payment-detail="true"
      :show-invoice-detail="true"
      :show-fba="false"
      :show-wht="true"
      view-source="tabWriteOffList"
      @queryResultCallBack="data => rowData = data"
      @clickedCallBack="row => clickRow = row"
      @doubleClickedCallBack="doubleClickedCallBack"
    >
      <div slot="operations">
        <!--复核-->
        <el-button v-permission="['button_ACWriteoff_approve']" type="primary" no="1" @click="approveHandler(null)">{{ $t('WriteOff.recheck') }}</el-button>
        <!--取消复核-->
        <el-button v-permission="['button_ACWriteoff_approve']" type="primary" no="2" @click="unapproveHandler">{{ $t('WriteOff.cancelRecheck') }}</el-button>
        <!--修改销账-->
        <el-button v-permission="['role_ACWriteoff_modifyWriteoff', 'button_ACWriteoff_modifyWriteoff']" type="primary" no="3" :disabled="clickRow===null" @click="editWriteoffHandler">{{ $t('WriteOff.editWriteOff') }}</el-button>
        <!--撤销销账-->
        <el-button v-permission="['button_ACWriteoff_cancelWriteOff', 'button_ACWriteoff_cancelOtherWriteOff']" type="primary" :disabled="clickRow===null || isExecuting" no="4" @click="cancelWriteoffHandler">{{ $t('WriteOff.cancelWriteOff') }}</el-button>
        <!--查看明细-->
        <el-button type="primary" :disabled="clickRow===null" no="5" @click="showDetailHandler">{{ $t('WriteOff.viewDetails') }}</el-button>
        <!--导出明细表-->
        <el-button type="primary" no="6" @click="exportHandler">{{ $t('WriteOff.exportExcel') }}</el-button>
        <!--凭证 -->
        <el-button type="primary" no="7" @click="viewAccountingDocumentClickHandler">{{ $t('WriteOff.proof') }}</el-button>
        <!--刷新汇率-->
        <el-button v-show="refreshRate" type="primary" no="8" @click="refreshRateHandler">{{ $t('WriteOff.refreshRate') }}</el-button>
        <!--刷新实际收付金额-->
        <el-button v-show="refreshRate" type="primary" no="9" @click="refreshPaymentHandler">{{ $t('WriteOff.refreshActualReceiptAndPaymentAmount') }}</el-button>
        <!--打印-->
        <el-button type="primary" :disabled="clickRow===null" no="10" @click="btnPrintHandler">{{ $t('WriteOff.print') }}</el-button>
        <!--同步核销单据-->
        <el-button v-if="((jydToFinanceApi && oversea === 0) || qlToFinanceApi) && $checkPermission(['button_ACWriteoff_syncCloud'])" type="primary" no="syncVerifyDoc" @click="syncCloudPlatform">{{ $t('CargoMsg.Cargo_SyncVerifyDoc') }}</el-button>
        <!--导出撤销历史-->
        <el-button type="primary" no="exportUndoHistory" @click="exportUndoHistoryHandler">{{ $t('CargoMsg.Cargo_ExportUndoHistory') }}</el-button>
      </div>
      <template v-slot:searchAreaHeader>
        <div class="app-main-inner-row  extension-conditions-form">
          <el-form :inline="true" label-position="left">
            <!--销账类型-->
            <el-form-item :label="$t('WriteOff.writeOffType')" class="el-form-item-search">
              <el-radio-group v-model="oversea" no="11">
                <!--全部-->
                <el-radio :label="-1">{{ $t('WriteOff.all') }}</el-radio>
                <!--国内-->
                <el-radio :label="0">{{ $t('WriteOff.domestic') }}</el-radio>
                <!--国外-->
                <el-radio :label="1">{{ $t('WriteOff.international') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <!--收付方式-->
            <el-form-item :label="$t('WriteOff.revenueAndExpenditureMethod')" class="el-form-item-search">
              <el-radio-group v-model="ar" no="12">
                <!--全部-->
                <el-radio :label="-1">{{ $t('WriteOff.all') }}</el-radio>
                <!--应收-->
                <el-radio :label="1">{{ $t('WriteOff.receivables') }}</el-radio>
                <!--应付-->
                <el-radio :label="0">{{ $t('WriteOff.payables') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <!--销账日期-->
            <el-form-item :label="$t('WriteOff.writeOffDate')" class="el-form-item-search">
              <el-row>
                <el-col :span="8">
                  <el-form-item label-width="0">
                    <el-date-picker
                      v-model="searchConditions.startDate"
                      type="date"
                      no="13"
                      :clearable="false"
                      value-format="yyyy-MM-dd"
                      :picker-options="pickerOptions"
                      :editable="false"
                      @change="exchangeDate"
                    /></el-form-item>
                </el-col>
                <el-col :span="2"><span>{{ $t('WriteOff.dateTo') }}</span></el-col>
                <el-col :span="8">
                  <el-form-item label-width="0">
                    <el-date-picker
                      v-model="searchConditions.endDate"
                      type="date"
                      no="14"
                      clearable
                      value-format="yyyy-MM-dd"
                      :picker-options="pickerOptions"
                      @change="exchangeDate"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label-width="0">
                    <el-checkbox id="lockConditions" v-model="allowTwoYearOutside" no="15">{{ $t('WriteOff.queryLotsOfData') }}</el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </write-off-search>
    <!--  修改核销记录弹窗  -->
    <edit-writeoff-dialog
      v-if="editDialog.show"
      :visible.sync="editDialog.show"
      :params="editDialog.params"
      :location="location"
      @successCallBack="refreshRow"
    />
    <!-- 查看明细 -->
    <write-off-detail-dialog
      :visible.sync="detailDialog.visible"
      :params="detailDialog.params"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
    <accounting-entry-window
      v-if="accountingEntryWindow.visible"
      :visible="accountingEntryWindow.visible"
      :is-ext="isExt"
      :prefix-data-provider="accountingEntryWindow.prefixDataProvider"
      :account-title-data-provider="accountingEntryWindow.accountTitleDataProvider"
      :mapping-departments="accountingEntryWindow.mappingDepartments"
      :mapping-staffs="accountingEntryWindow.mappingStaffs"
      :voucher="accountingEntryWindow.rowData"
      :index="accountingEntryWindow.index"
      :account-set="accountingEntryWindow.accountSet"
      :check="activeEditVoucherVerification"
      :check-department="checkDepartmentAccountingItem"
      @close="() => accountingEntryWindow.visible=false"
    />
    <date-selector
      v-if="dateSelecterDialog.visible"
      ref="dateSelecter"
      :account-set="null"
      :visible="dateSelecterDialog.visible"
      :current-state="dateSelecterDialog.currentState"
      :biz-data-type="dateSelecterDialog.bizDataType"
      :source="dateSelecterDialog.source"
      :non-group-data="dateSelecterDialog.nonGroupData"
      :show-account-set-select="dateSelecterDialog.showAccountSetSelect"
      :office-id="dateSelecterDialog.officeId"
      :generate-type="'commit'"
      @select="selectDataHandler"
      @groupCommit="selectDataHandler"
      @cancel="() => dateSelecterDialog.visible=false"
    />
  </div>
</template>

<script>
import writeOffSearch from '@/views/cargo/v0/Clearing/components/Writeoff/writeOffSearch'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import writeOffDetailDialog from './writeOffDetailDialog'
import editWriteoffDialog from './editWriteoffDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import DateUtils from '@/utils/dateUtils'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { cache, cacheName } from '@/utils/cacheManager'
import * as writeoffApi from '@/api/act/writeoff'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import StrUtils from '@/utils/StrUtils'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import { ChargeItem } from '@/class/model/mdm/chargeItem'
import moment from 'moment'
import { formatNumberToThousands } from '@/utils'
import LocalStorageUtils from '@/utils/localStorageUtilsNew'
import { getBankAccountList } from '@/api/bankAccount'
import {
  checkActualGenerateAccountingDocument,
  checkSpecialCharge,
  checkActualAmountToYYU8,
  syncActualAmountToYYU8, revocationWriteOffHistoryFunc, syncCloudPlatformQL
} from '@/api/clearing/actualAmount'
import AccountingEntryWindow from '@/views/cargo/v0/FinanceManage/VoucherMaintenance/AccountingEntryWindow'
import DateSelector from '@/views/cargo/v0/FinanceManage/VoucherMaintenance/DateSelector'
import { generateVoucher, queryActualAmountAccountingDocument } from '@/api/financeManage/accountingDocument'
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import { query } from '@/api/financeManage/accountSet'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import { LOG_WRITE_OFF } from '@/class/cargo/model/parameters/SystemConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'TabWriteOffList',
  components: {
    writeOffSearch,
    searchItem,
    writeOffDetailDialog,
    editWriteoffDialog,
    AccountingEntryWindow,
    DateSelector,
    cargoTemplateSelectorDialog,
    ChargeCurrencyTotalGroup
  },
  data() {
    return {
      simQueryPlaceholder: this.$t('WriteOff.writeOffSerialNumber'),
      refreshRate: false,
      clickRow: null,
      oversea: 0,
      ar: -1,
      verfDate: null,
      accountSetList: [], // 当前分公司的账套列表
      selectedKeys: [], // 当前勾选的数据
      activeEditVoucherVerification: false, // 是否开启生成凭证保存校验
      checkDepartmentAccountingItem: false, // 校验损益类科目的部门为虚拟部门
      isExt: false,
      jinRongExchangeMode: false, // 锦荣交单模式
      accountingEntryWindow: {
        visible: false,
        index: -1,
        accountSet: null,
        rowData: [],
        prefixDataProvider: [],
        accountTitleDataProvider: [],
        mappingDepartments: [],
        mappingStaffs: []
      },
      dateSelecterDialog: {
        visible: false,
        currentState: 'normal', // normal/ext
        bizDataType: 0,
        nonGroupData: [],
        source: 'writeOff',
        showAccountSetSelect: false,
        officeId: this.$store.getters.currentOfficeId
      },
      searchConditions: {
        startDate: '', // 销账日期开始
        endDate: '' // 销账日期结束
      },
      customSearchItems: [],
      pickerOptions: { // 设置可选时间范围
        disabledDate: this.disabledDate
      },
      allowTwoYearOutside: false,
      loading: false,
      exportColumnFields: [
        {
          headerName: this.$t('WriteOff.writeOffSerialNumber'), field: 'actualAmountNo',
          cellStyle: (params) => {
            if (!params.data) return null
            if (params.data.importData === true) {
              return { color: '#67C23A' }
            }
            return { color: '#409EFF' }
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_WriteoffSeqNo'), field: 'writeoffSeqNo'
        },
        {
          field: 'accountId', headerName: this.$t('WriteOff.settleAccountsTo'),
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }, {
          field: 'jobNo', headerName: this.$t('WriteOff.businessNumber')
        }, {
          field: 'mbl', headerName: this.$t('WriteOff.mbl'),
          cellRenderer: params => {
            return params.value + ' '
          }
        }, {
          field: 'hbl', headerName: this.$t('WriteOff.separateNumber'),
          cellRenderer: params => {
            return params.value + ' '
          }
        }, {
          field: 'jobLob', headerName: this.$t('WriteOff.businessType'),
          cellRenderer: params => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CustomJobType'),
          field: 'customJobType',
          width: 150,
          cellRenderer: params => {
            return ColumnUtils.customJobTypeLabelFunc2(params.value)
          }
        },
        {
          field: 'businessDate', headerName: this.$t('WriteOff.businessDate'),
          cellRenderer: params => {
            return DateUtils.customFormat(params.value, DateUtils.STANDARD_DATE)
          }
        },
        {
          field: 'invoiceNo', headerName: this.$t('WriteOff.invoiceNo'),
          cellRenderer: params => {
            return params.value + ' '
          }
        }, {
          field: 'chargeItemId', headerName: this.$t('WriteOff.chargeItem'),
          cellRenderer: params => {
            return this.chargeNameLabelFun(params.data, params.colDef.field)
          }
        }, {
          field: 'clearCurrency', headerName: this.$t('WriteOff.writeOffCurrency')
        }, {
          field: 'clearAmount', headerName: this.$t('WriteOff.theAmountOfWriteOffs'),
          cellRenderer: params => {
            return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2))
          }
        }, {
          field: 'clearRate', headerName: this.$t('WriteOff.writeOffExchangeRate'),
          cellRenderer: params => {
            return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 6))
          }
        }, {
          field: 'currency', headerName: this.$t('WriteOff.chargeOriginalCurrency')
        }, {
          field: 'amount', headerName: this.$t('WriteOff.chargeOriginalAmount'),
          cellRenderer: params => {
            return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2))
          }
        }, {
          field: 'rate', headerName: this.$t('WriteOff.chargeOriginalExchangeRate'),
          cellRenderer: params => {
            return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 8))
          }
        }, {
          field: 'bankWaterNo', headerName: this.$t('WriteOff.proofNo'),
          cellRenderer: params => {
            return params.value + ' '
          }
        }, {
          field: 'title', headerName: this.$t('WriteOff.invoiceHeader')
        }, {
          field: 'billingNo', headerName: this.$t('WriteOff.billNo')
        }, {
          field: 'otherPartyBilling', headerName: this.$t('Billing.billingJob_otherPartyBilling')
        }, {
          field: 'counterPartyBillingNos', headerName: this.$t('Billing.billingJob_agentBillNo')
        }, {
          field: 'verificationDate', headerName: this.$t('WriteOff.writeOffDate'),
          cellRenderer: params => {
            return DateUtils.customFormat(params.value, DateUtils.STANDARD_DATE)
          }
        }, {
          field: 'type', headerName: this.$t('WriteOff.paymentType'),
          cellRenderer: params => {
            return ColumnUtils.amountReceiveTypeLabelFun(params.value)
          }
        }, {
          field: 'ar', headerName: this.$t('WriteOff.revenueAndExpenditureType'),
          cellRenderer: params => {
            if (!params.data.hasOwnProperty(params.colDef.field)) return ''
            return params.value ? this.$t('Message.Receivable') : this.$t('Message.Payable')
          }
        }, {
          field: 'ourBank',
          headerName: this.$t('WriteOff.ourSideBank'),
          cellRenderer: params => {
            const cxt = this.$refs.searchItem
            return cxt && cxt.queryOurBankLabelFunc ? cxt.queryOurBankLabelFunc(params.data) : (params.value || '')
          }
        }, {
          field: 'rmbAmount', headerName: this.$t('WriteOff.rmbAmount'),
          cellRenderer: params => {
            return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2))
          }
        }, {
          field: 'usdAmount', headerName: this.$t('WriteOff.usdAmount'),
          cellRenderer: params => {
            return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2))
          }
        }, {
          field: 'payDate', headerName: this.$t('WriteOff.revenueAndExpenditureDate'),
          cellRenderer: params => {
            return DateUtils.customFormat(params.value, DateUtils.STANDARD_DATE)
          }
        },
        {
          headerName: this.$t('Payment.chargeRemark'),
          field: 'remarks',
          minWidth: 130,
          width: 130
        },
        {
          field: 'sales', headerName: this.$t('WriteOff.sales'),
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          field: 'op', headerName: this.$t('WriteOff.operation'),
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          field: 'customerId', headerName: this.$t('WriteOff.consignationCompany'),
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }, {
          field: 'billingGroupNo', headerName: this.$t('WriteOff.accountStatementNo')
        }, {
          headerName: this.$t('CargoMsg.Cargo_billPaymentNo'), field: 'billPaymentNo'
        }, {
          headerName: this.$t('WriteOff.ChargeOriginTotalAmount'),
          field: 'chargeAmount',
          cellRenderer: (params) => {
            return Number(params.value).toFixed(2)
          }
        }, {
          headerName: 'ETD',
          field: 'ETD',
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        }, {
          headerName: 'ETA',
          field: 'ETA',
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        }, {
          headerName: 'ATD',
          field: 'ATD',
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        }, {
          headerName: 'ATA',
          field: 'ATA',
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        }, {
          headerName: this.$t('WriteOff.theOppositeSideBank'),
          field: 'companyBank',
          colId: 'companyBank',
          width: 100,
          hide: true
        }, {
          headerName: this.$t('WriteOff.theOppositeSideAccount'),
          field: 'companyBankAccount',
          colId: 'companyBankAccount',
          width: 100,
          hide: true
        }
      ],
      exportHistoryColumnFields: [
        {
          headerName: this.$t('CargoMsg.Cargo_WriteOffSerialNumber'), field: 'actualAmountNo'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WriteoffSeqNo'), field: 'writeOffSeqNo'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RevocationBy'), field: 'revocationBy',
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RevocationByDate'), field: 'revocationDate',
          cellRenderer: params => {
            return DateUtils.formatStandardDateTime(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo'), field: 'accountId',
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('Invoice.invoice_invoiceNo'), field: 'invoiceNos'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WriteOffCurrency'), field: 'currency'
        },
        {
          headerName: this.$t('Invoice.invoice_theAmountOfWriteOffs'), field: 'amount',
          cellRenderer: params => {
            return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2))
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WriteOffRate'), field: 'rate',
          cellRenderer: params => {
            return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 8))
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_VoucherNo'), field: 'voucherNo'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BillNo'), field: 'billingNos'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WriteOffDate'), field: 'verificationDate'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PaymentType'), field: 'ar',
          cellRenderer: params => {
            if (!params.data.hasOwnProperty(params.colDef.field)) return ''
            return params.value ? this.$t('Message.Receivable') : this.$t('Message.Payable')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PaymentReceiveType'), field: 'type',
          cellRenderer: params => {
            return ColumnUtils.amountReceiveTypeLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OurBank'),
          field: 'ourBank',
          cellRenderer: params => {
            const cxt = this.$refs.searchItem
            return cxt && cxt.queryOurBankLabelFunc ? cxt.queryOurBankLabelFunc(params.data) : (params.value || '')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PayReceiveDate'), field: 'payReceiveDate',
          cellRenderer: params => {
            return DateUtils.formatStandardDateTime(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_billPaymentNo'), field: 'billPaymentNos'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TheOppositeSideBank'), field: 'companyBank'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CounterpartySBankAccount'), field: 'companyBankAccount'
        }
      ],
      rowData: [],
      editDialog: {
        show: false,
        params: {}
      },
      detailDialog: {
        visible: false,
        params: {}
      },
      templateSelectorDialog: {// 模板选择弹窗
        visible: false,
        ctx: null,
        category: '',
        data: {}
      },
      executing: false, // 执行中
      location: LOG_WRITE_OFF.code,
      jydToFinanceApi: false, // 集翊达用友U8CLOUD
      syncCloudPlatAble: true, // 能否访问U8接口
      qlToFinanceApi: false // 青旅同步
    }
  },
  computed: {
    gridOptions() {
      return this.$refs.searchItem.gridOptions
    },
    isExecuting() {
      return this.executing
    }
  },
  watch: {
    async allowTwoYearOutside(val) {
      await this.lockConditionsCheckedHandler(val)
    },
    oversea(val) {
      LocalStorageUtils.setConfiguration('WriteOff', val)
    },
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        await cache.load(cacheName.CONFIG)
        this.jinRongExchangeMode = cache.config.get('ToExoSystem') === 'JinRongExchangeMode' // 锦荣交单模式
        this.jydToFinanceApi = cache.config.get('ToFinanceApi') === 'JYDYY' // 集翊达用友U8CLOUD
        this.qlToFinanceApi = cache.config.get('ToFinanceApi') === 'QL' // 青旅202507
      }
    }
  },
  async created() {
    this.refreshRate = this.$store.getters.isAdmin && this.$store.getters.userInfo.chineseName === '平台客服'
    // 默认核销开始日期为2年前
    this.searchConditions.startDate = DateUtils.customFormat(this.getTowYearBeforeDate(), DateUtils.STANDARD_DATE)
    // 取默认的国内外类型
    this.oversea = Number(LocalStorageUtils.getConfiguration('WriteOff'))
    this.initConfig()
  },
  methods: {
    isWriteoffOperator(actualAmount) {
      return this.$store.getters.userId === actualAmount.verificationBy
    },
    hasWriteoffOperatePermission(allPermissions, personalPermissions, actualAmount) {
      if (this.$store.getters.isAdmin) {
        return true
      }
      if (this.$checkPermission(allPermissions)) {
        return true
      }
      return this.isWriteoffOperator(actualAmount) && this.$checkPermission(personalPermissions)
    },
    // 配置参数
    initConfig() {
      this.isExt = Number(cache.config.get('ext')) === 1
      this.activeEditVoucherVerification = Number(cache.config.get('activeEditVoucherVerification')) === 1
      this.checkDepartmentAccountingItem = Number(cache.config.get('CheckDepartmentAccountingItem')) === 1
    },
    // 判断开始和结束日期是否需要调换位置
    exchangeDate() {
      const start = this.searchConditions.startDate
      const end = this.searchConditions.endDate
      if (start && end) {
        const startDate = moment(start)
        const endDate = moment(end)
        if (startDate > endDate) {
          this.searchConditions.startDate = end
          this.searchConditions.endDate = start
        }
      }
    },
    // 设置不可选日期范围
    disabledDate(currDate) {
      if (!this.allowTwoYearOutside) {
        const beforeTwoYear = moment().subtract(2, 'y').subtract(1, 'days')
        return currDate < beforeTwoYear
      }
      return false
    },
    // 查询前置条件
    preQuery() {
      // 销账日期，必须不为空
      const verfDate = this.getVerificationDateSearchOption()
      if (!verfDate) {
        this.$message.info(this.$t('WriteOff.writeOffDateNotEmpty'))
        return false
      }
      this.verfDate = verfDate
      return true
    },
    // 默认查询条件
    getVerificationDateSearchOption() {
      return this.doVerificationDateSearchOption('actualAmount.VERIFICATIONDATE')
    },
    doVerificationDateSearchOption(value) {
      let start
      if (this.searchConditions.startDate) {
        start = 'start=' + this.searchConditions.startDate + ' 00:00:00'
      }
      let end
      if (this.searchConditions.endDate) {
        end = 'end=' + this.searchConditions.endDate + ' 23:59:59'
      }
      if (start || end) {
        const type = 'type=date'
        const str = start + ',' + end + ',' + type
        return new AdvancedSearchOption('dateRange', value, str, AdvancedSearchConsts.OPERATOR_RANGE.code)
      }
      return null
    },
    // 复核 按钮事件
    async approveHandler(row) {
      let selections
      if (row) {
        // 有传入行数据时复核该数据
        selections = [row]
      } else {
        // 没有传入行数据时复核勾选行数据
        selections = this.gridOptions.api.getSelectedRows()
      }
      if (selections.length === 0) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelectRecordToReview'))
        return
      }
      const actualAmountUuids = []
      // ActualAmount
      for (const act of selections) {
        if (act.approvedState === ClearingConstants.ACT_AMOUNT_APPROVE_NONE.code) {
          actualAmountUuids.push(act.uuid)
        }
      }
      if (actualAmountUuids.length === 0) {
        this.$message.info(this.$t('CargoMsg.Cargo_OnlyUnCheckedRecordsCanBeChecked'))
      } else {
        await this.$confirm(this.$t('CargoMsg.Cargo_ConfirmAndCheckSelectedRecord'), this.$t('CargoMsg.Cargo_Tips'), { closeOnClickModal: false, closeOnPressEscape: false, type: 'warning' })
        const approvedState = ClearingConstants.ACT_AMOUNT_APPROVED.code
        const params = {
          actualAmountUuids,
          approvedState
        }
        const loading = getLoading4Cxt()
        writeoffApi.batchUpdateApprovedState(params).then(res => {
          const actualAmountUuids = res.data.updateUuids
          // CARGO-17570 若高级查询包含是否复核且只含 未复核 情况下，将复核成功的项隐藏
          // 高级查询是否仅有未复核条件
          let onlyNotApproved = false
          const conditionsAndRequires = this.$refs.searchItem.conditionsAndRequires
          if (conditionsAndRequires && conditionsAndRequires.conditions) {
            const approvedState = conditionsAndRequires.conditions.find(condition => condition.fieldName === 'actualAmount.APPROVED_STATE')
            if (approvedState && approvedState.value && approvedState.value.length === 1 && approvedState.value[0] === 0) {
              onlyNotApproved = true
            }
          }
          if (onlyNotApproved) {
            // 过滤复核成功的项
            const rows = this.rowData.filter(row => actualAmountUuids.includes(row.uuid))
            this.gridOptions.api.updateRowData({ remove: rows })
          } else {
            // 将复核成功的数据局部更新后重新渲染
            const actualAmountData = res.data.actualAmountData
            if (actualAmountData) {
              const actualAmountMap = new Map()
              for (const actualAmount of actualAmountData) {
                actualAmountMap.set(actualAmount.uuid, actualAmount)
              }
              for (const row of this.rowData) {
                const actualAmount = actualAmountMap.get(row.uuid)
                if (actualAmount) {
                  row.approvedState = actualAmount.approvedState
                  row.approvedBy = actualAmount.approvedBy
                  row.dateApproved = actualAmount.dateApproved
                  row.jdyxkSyncStatus = actualAmount.jdyxkSyncStatus
                  row.jdyxkSyncFailReason = actualAmount.jdyxkSyncFailReason
                }
              }
            }
          }
          if (res.data.jinRongExchange) {
            this.$message.success(this.$t('FinanceManage.SyncCloudSucceededXFailedX', [res.data.jinRongExchange.successCount, res.data.jinRongExchange.failCount]))
            setTimeout(() => {
              if (res.data.jinRongExchange.failCount === 0) {
                this.$message.success(this.$t('CargoMsg.Cargo_ReCheckedSuccessfully'))
              } else {
                this.$message.warning(this.$t('CargoMsg.Cargo_ReCheckedFailed'))
              }
            }, 100)
          } else {
            this.$message.success(this.$t('CargoMsg.Cargo_ReCheckedSuccessfully'))
          }
          this.gridOptions.api.refreshCells({ force: true })
        }).catch(() => {
          this.faultHandler()
        }).finally(() => {
          loading.close()
        })
        // Session.getInstance().saveAll(list, new mx.rpc.Responder(approveResultHandler, faultHandler),
        // Session.getInstance().clazzAndFunctionName(this, arguments.callee, "approveHandler"));
      }
    },
    // 取消复核 按钮事件
    async unapproveHandler() {
      const selections = this.gridOptions.api.getSelectedRows()
      if (selections.length === 0) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelectRecordToCancelReview'))
        return
      }
      const actualAmountUuids = []
      // ActualAmount
      for (const act of selections) {
        if (act.approvedState === ClearingConstants.ACT_AMOUNT_APPROVED.code) {
          actualAmountUuids.push(act.uuid)
        }
      }
      if (actualAmountUuids.length === 0) {
        this.$message.info(this.$t('CargoMsg.Cargo_OnlyCheckedRecordsCanBeCancelled'))
      } else {
        await this.$confirm(this.$t('CargoMsg.Cargo_CancelCheckOfSelectedRecord'), this.$t('CargoMsg.Cargo_Tips'), { closeOnClickModal: false, closeOnPressEscape: false, type: 'warning' })
        const approvedState = ClearingConstants.ACT_AMOUNT_APPROVE_NONE.code
        const params = {
          actualAmountUuids,
          approvedState
        }
        const loading = getLoading4Cxt()
        await writeoffApi.batchUpdateApprovedState(params).then(res => {
          // 将复核成功的数据局部更新后重新渲染
          const actualAmountUuids = res.data.updateUuids
          for (const uuid of actualAmountUuids) {
            const row = this.rowData.find(p => p.uuid === uuid)
            if (row) {
              row.approvedState = approvedState
              row.approvedBy = 0
              row.dateApproved = null
            }
          }
          this.gridOptions.api.refreshCells({ force: true })
          this.$message.success(this.$t('CargoMsg.Cargo_CancelReCheckedSuccessfully'))
        }).catch(() => {
          this.faultHandler()
        }).finally(() => {
          loading.close()
        })
        // Session.getInstance().saveAll(list, new mx.rpc.Responder(unApproveResultHandler, faultHandler),
        //   Session.getInstance().clazzAndFunctionName(this, arguments.callee, "unapproveHandler"));
      }
    },
    // 编辑销账 按钮事件
    async editWriteoffHandler() {
      const actualAmount = this.clickRow
      if (!actualAmount) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelectWriteOffRecord'))
        return
      } else if (actualAmount.approvedState !== ClearingConstants.ACT_AMOUNT_APPROVE_NONE.code) {
        this.$message.info(this.$t('CargoMsg.Cargo_CTMCWOPCCF'))
        return
      } else if (this.jinRongExchangeMode && actualAmount.jdyxkSyncStatus !== ChargeConstants.JDYXK_NOT_SYNC.code && actualAmount.jdyxkSyncStatus !== ChargeConstants.JDYXK_SYNC_FAIL.code) {
        this.$message.warning(this.$t('WriteOff.NotSyncCannotModify'))
        return
      } else if (!this.hasWriteoffOperatePermission(['role_ACWriteoff_modifyWriteoff'], ['button_ACWriteoff_modifyWriteoff'], actualAmount)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OTWOOCMI'))
        return
      }
      const params = {}
      // 重新查询
      const queryParams = {
        branchId: this.$store.getters.currentOfficeId,
        conditions: [new AdvancedSearchOption('FIELD_TEXT', 'actualAmount.UUID', actualAmount.uuid, AdvancedSearchConsts.OPERATOR_EQUAL.code).formatObj2Json()],
        requires: {},
        pageSize: 1,
        pageNum: 1
      }
      const self = this
      params.model = await writeoffApi.queryActualAmountPageable(queryParams).then(res => res.data.list[0]).catch(err => {
        self.faultHandler(err)
      })
      if (!params.model || (params.model.branchId !== this.$store.getters.currentOfficeId)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      params.lbPayReceive = actualAmount.ar ? this.$t('Payment.receipt') : this.$t('Payment.payment')
      params.editType = parseInt(cache.config.get('ActualAmountEditType')) === 1
      this.editDialog.params = params
      this.editDialog.show = true
    },
    // 撤销销账 按钮事件
    cancelWriteoffHandler() {
      if (this.isExecuting) return
      const actualAmount = this.clickRow
      if (actualAmount == null) {
        this.$confirm(this.$t('CargoMsg.Cargo_PleaseSelectWriteOffRecord'), this.$t('CargoMsg.Cargo_Tips'), { closeOnClickModal: false, closeOnPressEscape: false, cancelButtonText: this.$t('CargoMsg.Cargo_Confirm'), showConfirmButton: false, type: 'warning' })
      } else if (this.jinRongExchangeMode && actualAmount.jdyxkSyncStatus !== ChargeConstants.JDYXK_NOT_SYNC.code && actualAmount.jdyxkSyncStatus !== ChargeConstants.JDYXK_SYNC_FAIL.code) {
        this.$message.warning(this.$t('WriteOff.NotSyncCannotModify'))
        return
      } else if (actualAmount.reconciliation) {
        this.$confirm(this.$t('CargoMsg.Cargo_PRSCSCRICP'), this.$t('CargoMsg.Cargo_Tips'), { closeOnClickModal: false, closeOnPressEscape: false, cancelButtonText: this.$t('CargoMsg.Cargo_Confirm'), showConfirmButton: false, type: 'warning' })
      } else if (actualAmount.approvedState !== ClearingConstants.ACT_AMOUNT_APPROVE_NONE.code) {
        this.$confirm(this.$t('CargoMsg.Cargo_CTRCWOPCCF'), this.$t('CargoMsg.Cargo_Tips'), { closeOnClickModal: false, closeOnPressEscape: false, cancelButtonText: this.$t('CargoMsg.Cargo_Confirm'), showConfirmButton: false, type: 'warning' })
      } else if (!StrUtils.isEmpty(actualAmount.redPunchActualAmountUuid)) {
        this.$confirm(this.$t('CargoMsg.Cargo_TWORHBRCC'), this.$t('CargoMsg.Cargo_Tips'), { closeOnClickModal: false, closeOnPressEscape: false, cancelButtonText: this.$t('CargoMsg.Cargo_Confirm'), showConfirmButton: false, type: 'warning' })
      } else if (!this.hasWriteoffOperatePermission(['button_ACWriteoff_cancelOtherWriteOff'], ['button_ACWriteoff_cancelWriteOff'], actualAmount)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OTWOOCCI'))
        return
      } else {
        if (this.isExecuting) return
        this.executing = true
        writeoffApi.checkExportedToVoucher({ actualAmountUuid: actualAmount.uuid }).then(res => {
          this.checkExportedToVoucherResultHandler(res)
          this.executing = false
        }).catch(err => {
          this.executing = false
          this.faultHandler()
        })
        // ActualAmount.checkExportedToVoucher(actualAmount.key, checkExportedToVoucherResultHandler, faultHandler);
      }
    },
    async checkExportedToVoucherResultHandler(event) {
      // Boolean
      const exist = event.data
      if (exist) {
        await this.$confirm(this.$t('CargoMsg.Cargo_VHBEFCWOWBRWBCITWORSTWB'), this.$t('CargoMsg.Cargo_Reverse'), { closeOnClickModal: false, closeOnPressEscape: false, type: 'warning' })
        await this.rollbackExecute()
      } else {
        await this.$confirm(this.$t('CargoMsg.Cargo_STRTWOREAIIWBR'), this.$t('CargoMsg.Cargo_Tips'), { closeOnClickModal: false, closeOnPressEscape: false, type: 'warning' })
        await this.rollbackExecute()
      }
    },
    async rollbackExecute() {
      const actualAmount = this.clickRow
      this.loading = getLoading()
      await writeoffApi.rollbackChargeWriteoff({ actualAmountUuid: actualAmount.uuid, location: this.location, branchId: actualAmount.branchId }).then(res => {
        this.rollbackSuccessHandler()
      }).catch(err => {
        this.$message.warning(this.$t('Clearing.FailedToRevokeReconciliation'))
      })
      this.loading.close()
      this.clickRow = null
      // ActualAmount.rollbackChargeWriteoff(actualAmount.key, new mx.rpc.Responder(rollbackSuccessHandler, faultHandler));
    },
    rollbackSuccessHandler() {
      this.$message.success(this.$t('CargoMsg.Cargo_WriteOffRevokedSuccessfully'))
      let index = this.rowData.findIndex(row => {
        return row.uuid === this.clickRow.uuid
      })
      this.rowData.splice(index, 1)
      this.clickRow = null
      if (this.rowData && this.rowData.length > 0) {
        index = this.rowData.length === index ? index - 1 : index
        this.clickRow = this.rowData[index]
      }
      this.gridOptions.api.refreshCells({ force: true })
    },
    // 查看销账明细 按钮事件
    showDetailHandler() {
      const actualAmount = this.clickRow
      if (actualAmount == null) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelectWriteOffRecord'))
        return
      }
      if (actualAmount.branchId !== this.$store.getters.currentOfficeId && !JobUtils.checkHierarchicalDetailFinancial(actualAmount.branchId)) {
        this.$message.warning(this.$t('Message.NoHasViewRole'))
        return
      }
      const params = {}
      params.actualAmount = actualAmount
      const selections = []
      selections.push(actualAmount)
      params.queryActualAmountSelections = selections
      params.hasApprove = true
      params.view = this
      this.detailDialog.params = params
      this.detailDialog.visible = true
    },
    // 刷新汇率(刷新汇率为0的数据) 按钮事件
    refreshRateHandler() {
      if (this.jinRongExchangeMode) {
        for (const row of this.rowData) {
          if (row.rate === 0 && row.jdyxkSyncStatus !== ChargeConstants.JDYXK_NOT_SYNC.code && row.jdyxkSyncStatus !== ChargeConstants.JDYXK_SYNC_FAIL.code) {
            this.$message.warning(this.$t('WriteOff.NotSyncCannotModify'))
            return
          }
        }
      }
      writeoffApi.refreshEmptyRate().then(res => {
        this.$message.success(this.$t('WriteOff.update') + res.data + this.$t('WriteOff.strip'))
        if (this.$refs.searchItem.conditionsAndRequires) {
          this.$refs.searchItem.query()
        }
      }).catch(err => {
        this.faultHandler()
      })
    },
    // 刷新实际收付金额 按钮事件
    async refreshPaymentHandler() {
      this.loading = getLoading()
      await writeoffApi.refreshEmpyPaymentAmount().then(res => {
        this.$message.success(this.$t('WriteOff.update') + res.data + this.$t('WriteOff.strip'))
        if (this.$refs.searchItem.conditionsAndRequires) {
          this.$refs.searchItem.query()
        }
      }).catch(err => {
        this.faultHandler()
      })
      this.loading.close()
    },
    /** *********按钮事件 end********** **/

    // 是否查询两年外数据 选中/取消选中 勾选框事件
    async lockConditionsCheckedHandler(checked) {
      // 计算两年前的日期
      const towYearBeforeDate = this.getTowYearBeforeDate()
      const dateStr = DateUtils.customFormat(towYearBeforeDate, DateUtils.STANDARD_DATE)
      if (checked) {
        await this.$confirm(this.$t('WriteOff.unlockWriteOffDateQuery'), this.$t('WriteOff.confirm'), { type: 'warning' }).catch(err => {
          this.allowTwoYearOutside = false
        })
        if (!this.allowTwoYearOutside) return
        // 销账日期变更为两年前的日期
        this.verfDateArray = [dateStr, dateStr]
      } else {
        // 判断日期
        let s = this.verfDateArray[0]
        if (!s) return
        s = s.replace(/-/g, '/')
        const date = new Date(s)
        if (date.getTime() < towYearBeforeDate.getTime()) {
          this.verfDateArray = [dateStr, dateStr]
        }
      }
    },
    // 获取两年前的日期对象，不传date默认为new Date()的两年前日期对象
    getTowYearBeforeDate(date) {
      if (!date) date = new Date()
      const year = date.getFullYear() - 2
      return new Date(year, date.getMonth(), date.getDate())
    },
    // 修改指定行数据并重新渲染列表
    refreshRow(data) {
      this.$refs.searchItem.refreshRow(data)
    },
    // 打印 按钮事件
    btnPrintHandler() {
      const selections = this.gridOptions.api.getSelectedRows()
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_WriteOffRecordsNotSelected'))
        return
      }
      const keyList = []
      for (const actualAmount of selections) {
        keyList.push(actualAmount.uuid)
      }
      const params = {}
      params.WRITEOFF_UUID_LIST = keyList
      params.WRITEOFF_UUID = params.WRITEOFF_UUID_LIST
      params.ACT_ACTUAL_AMOUNT_UUID = params.WRITEOFF_UUID_LIST
      params.invoiceNo = selections[0].invoiceNo
      if (selections[0].jobNo != null) {
        params.jobNo = selections[0].jobNo
      }
      // TemplateSelectorWin.getInstance().showThisWin(null, "WRITEOFF", params, this)
      this.templateSelectorDialog.ctx = null
      this.templateSelectorDialog.category = 'WRITEOFF'
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.visible = true
    },
    exportUndoHistoryHandler() {
      const date = this.doVerificationDateSearchOption('rw.VERIFICATION_DATE')
      if (!date) {
        this.$message.info(this.$t('WriteOff.writeOffDateNotEmpty'))
        return false
      }
      this.loading = getLoading4Cxt()
      const item = {}
      item.conditions = [date]
      item.branchId = this.$store.getters.currentOfficeId
      revocationWriteOffHistoryFunc(item).then(res => {
        const rows = res.data
        this.exportExcelHandler('historyExport', rows, this.exportHistoryColumnFields)
      }).finally(() => {
        this.loading.close()
      })
    },
    exportExcelHandler(fileName, rows, columnFields) {
      // 获取选中行
      const tHeader = []
      const filterVal = []
      // 对行中每列的值做处理
      for (const item of rows) {
        if (!item) continue
        for (const colDef of columnFields) {
          const dataField = colDef.field
          if (!colDef.headerName || !dataField) continue
          if (!tHeader.includes(colDef.headerName) && !filterVal.includes(dataField)) {
            tHeader.push(colDef.headerName)
            filterVal.push(dataField)
          }
          let data = item.hasOwnProperty(dataField) ? item[dataField] : ''
          // 进行labelFunction 处理
          if (colDef.cellRenderer && typeof colDef.cellRenderer !== 'string') {
            const params = { data: item, value: item[dataField] }
            params.colDef = { field: colDef.field }
            data = colDef.cellRenderer(params)
          }
          if (data && typeof data === 'string') {
            data = StrUtils.replaceSpecialCharacter(data)
          }
          item[dataField] = data
        }
      }
      import('@/vendor/Export2Excel').then(excel => {
        const data = this.formatJson(filterVal, rows)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: fileName
        })
      })
    },
    async viewAccountingDocumentClickHandler() {
      this.selectedKeys = []
      const idList = []
      const selectedRows = this.gridOptions.api.getSelectedRows()
      for (const actualAmount of selectedRows) {
        idList.push(actualAmount.uuid)
      }
      if (!idList || idList.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSRTCV'))
        return
      }
      const bankAccounts = await getBankAccountList(this.$store.getters.currentOfficeUuid).then(res => res.data)
      if (bankAccounts) {
        let isSameCurrency = true
        for (const actualAmount of selectedRows) {
          if (!StrUtils.isEmpty(actualAmount.currency) && !StrUtils.isEmpty(actualAmount.ourBankAccount)) {
            // 分公司银行账号
            if (bankAccounts) {
              isSameCurrency = false
              for (const bank of bankAccounts) {
                if (!StrUtils.isEmpty(bank.currency) && actualAmount.currency === bank.currency && !StrUtils.isEmpty(bank.accountNo) && actualAmount.ourBankAccount === bank.accountNo) {
                  isSameCurrency = true // 币种相同
                  break
                }
              }
              if (!isSameCurrency) {
                this.$message.warning(this.$t('CargoMsg.Cargo_CurrencyMismatch', [actualAmount.actualAmountNo]))
                return
              }
            }
          }
        }
      }
      this.selectedKeys = idList
      const enableCommission = parseInt(cache.config.get('enableCommission')) === 1
      if (enableCommission) {
        this.loading = getLoading()
        checkSpecialCharge(idList).then(res => {
          console.log('checkSpecialCharge', res)
          this.checkSuccessFunc(res.data)
        }).finally(() => {
          this.loading.close()
        })
      } else {
        checkActualGenerateAccountingDocument(this.selectedKeys).then(res => {
          this.checkActualAmount(res.data)
        })
      }
    },
    checkSuccessFunc(result) {
      if (result) {
        this.$message.warning(this.$t('Message.checkSpecialChargeTips'))
        return
      } else {
        checkActualGenerateAccountingDocument(this.selectedKeys).then(res => {
          this.checkActualAmount(res.data)
        })
      }
    },
    checkActualAmount(result) {
      if (!result || result.length === 0) {
        if (!this.selectedKeys || this.selectedKeys.length === 0) {
          this.$message.warning(this.$t('Message.Cargo_PSRTCV'))
          return
        }
        this.displayVoucher()
      } else {
        // 生成凭证
        const collection = []
        let actualAmountNo = ''
        let officeId = 0
        for (const item of result) {
          if (item) {
            officeId = item.branchId
            collection.push(item)
            actualAmountNo += StrUtils.isEmpty(actualAmountNo) ? item.actualAmountNo : (',' + item.actualAmountNo)
          }
        }
        if (collection.length > 0) {
          this.$confirm(actualAmountNo + this.$t('CargoMsg.Cargo_VoucherNotCreatedCreateItNow'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            this.dateSelecterDialog.showAccountSetSelect = true
            this.dateSelecterDialog.currentState = 'ext'
            this.dateSelecterDialog.bizDataType = FinanceInterfaceConstants.RECEIPT_PAYMENT.code
            this.dateSelecterDialog.nonGroupData = collection
            this.dateSelecterDialog.officeId = officeId
            this.dateSelecterDialog.visible = true
          })
        }
      }
    },
    async displayVoucher(idList) {
      this.loading = getLoading()
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        mode: 'office',
        loadFiscalPeriodInfoFlag: true,
        loadAccountingDocumentTypeFlag: true,
        loadAccountTitleFlag: true,
        loadMappingDepartmentsFlag: true,
        loadMappingStaffsFlag: true,
        loadAccountingDocumentsRuleFlag: false,
        loadCurrentRatesFlag: false,
        loadUsedCurrencyFlag: false
      }
      await query(params).then(res => {
        this.accountSetList = res.data.list
      })
      queryActualAmountAccountingDocument(this.selectedKeys).then(res => {
        const voucherList = res.data
        if (voucherList && voucherList.length > 0) {
          this.accountingEntryWindow.visible = true
          this.accountingEntryWindow.multiAccountSet = true
          this.accountingEntryWindow.rowData = voucherList
          const accountSetUuid = voucherList[0].accountSetUuid
          this.accountingEntryWindow.accountSet = this.accountSetList.find(item => {
            return item.uuid === accountSetUuid
          })
          this.accountingEntryWindow.index = 0
          if (this.accountingEntryWindow.accountSet) {
            const prefixList = []
            for (const accountingDocumentType of this.accountingEntryWindow.accountSet.accountingDocumentType) {
              if (prefixList.length === 0) {
                prefixList.push(accountingDocumentType)
              } else {
                let bExist = false
                for (const prefixData of prefixList) {
                  if (prefixData.prefix === accountingDocumentType.prefix) {
                    bExist = true
                    break
                  }
                }
                if (!bExist) prefixList.push(accountingDocumentType)
              }
            }
            this.accountingEntryWindow.prefixDataProvider = prefixList
            this.accountingEntryWindow.accountTitleDataProvider = this.accountingEntryWindow.accountSet.accountTitle || []
            this.accountingEntryWindow.mappingDepartments = this.accountingEntryWindow.accountSet.mappingDepartments || []
            this.accountingEntryWindow.mappingStaffs = this.accountingEntryWindow.accountSet.mappingStaffs || []
          }
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 导出excel操作处理器
    async exportHandler() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      const self = this
      if (selectedRows.length === 0) {
        // self.$message.warning(this.$t('CargoMsg.Cargo_NoData'))
        this.$confirm(this.$t('CargoMsg.Cargo_PleaseSelectDataToExport'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'warning'
        }).then(() => {
          //
        }).catch(() => {
          //
        })
        return
      } else {
        this.$message.success(this.$t('Message.RequestSucceededExporting'))
      }
      const uids = []
      for (const row of selectedRows) {
        uids.push(row.uuid)
      }
      const rows = await writeoffApi.queryActualAmountsByID(uids).then(res => res.data).catch(err => this.faultHandler(err))
      const timestamp = new Date().getTime()
      console.log('====开始时间======', timestamp)
      // 获取选中行
      this.exportExcelHandler('AccountDetails', rows, this.exportColumnFields)
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    chargeNameLabelFun(data, dataField) {
      const chargeItem = ChargeItem.getChargeItemById(data[dataField])
      if (chargeItem) {
        return this.$store.getters.language === 'zh' ? chargeItem.zhName : chargeItem.enName
      }
      return ''
    },
    doubleClickedCallBack(data) {
      this.clickRow = data
      this.showDetailHandler()
    },
    selectDataHandler() {
      const voucherDate = this.$refs.dateSelecter.selectedDate()
      const dateType = this.$refs.dateSelecter.selectedDateType() // 日期类型
      const accountSetDDL = this.$refs.dateSelecter.accountSetDDL
      const keyCollection = []
      for (const item of this.$refs.dateSelecter.nonGroupData) {
        keyCollection.push(item.uuid)
      }
      this.dateSelecterDialog.visible = false
      // CARGO-1532，销账窗口生成凭证和生成凭证窗口生成的凭证字不同
      let isGroupGen = this.isExt
      if (parseInt(cache.config.get('isGroupGenNotByEXT')) === 1) {
        isGroupGen = false
        if (keyCollection.length > 1) {
          isGroupGen = true
        }
      }
      const requestBody = {
        'accountSetKey': accountSetDDL,
        'bizType': FinanceInterfaceConstants.RECEIPT_PAYMENT.code,
        'voucherDate': voucherDate,
        'keys': keyCollection,
        'isGroupGen': isGroupGen,
        'autoVerify': false,
        'isRedPunch': false,
        'branchId': this.$store.getters.currentOfficeId,
        'dateType': dateType
      }
      this.loading = getLoading()
      generateVoucher(requestBody).then(res => {
        console.log('generateVoucher', res.data)
        const documents = res.data
        this.generateResultHandler(documents)
      }).finally(() => {
        this.$refs.searchItem.query()
        this.loading.close()
      })
    },
    generateResultHandler(documents) {
      this.displayVoucher()
    },
    faultHandler() {
      this.$message.warning(this.$t('CargoMsg.Cargo_SystemBusyPRL'))
    },
    // 同步核销单据
    async syncCloudPlatform() {
      if (!this.syncCloudPlatAble) {
        return
      }
      this.syncCloudPlatAble = false
      const loading = getLoading4Cxt(this)
      if (this.jydToFinanceApi) {
        try {
          if (!await this.checkActualAmountToYYU8()) {
            loading.close()
            this.syncCloudPlatAble = true
            return
          }
        } catch (e) {
          loading.close()
          this.syncCloudPlatAble = true
          return
        }
      }

      const rows = this.gridOptions.api.getSelectedRows()
      const keys = Array.from(rows, p => p.uuid)

      if (this.jydToFinanceApi) {
        syncActualAmountToYYU8({ keys: keys, branchId: this.$store.getters.currentOfficeId }).then(res => {
          loading.close()
          const result = res.data
          if (result) {
            const successSize = result.successList ? result.successList.length : 0
            const failSize = result.failList ? result.failList.length : 0
            this.$message.success(this.$t('SystemDocking.Success0entriesFailure0entries', [successSize, failSize]))
            this.$refs.searchItem.query()
          }
        }).catch(() => {
          loading.close()
        }).finally(() => {
          this.syncCloudPlatAble = true
        })
      }

      if (this.qlToFinanceApi) {
        const rows = this.gridOptions.api.getSelectedRows()
        if (rows.length === 0) {
          this.syncCloudPlatAble = true
          this.$message.warning(this.$t('CargoMsg.Cargo_WriteOffRecordsNotSelected'))
          loading.close()
          return false
        }

        syncCloudPlatformQL({ keys: keys, branchId: this.$store.getters.currentOfficeId }).then(res => {
          this.$message.success(this.$t('Message.SynchronizationSucceeded'))
        }).catch(() => {

        }).finally(() => {
          loading.close()
          this.syncCloudPlatAble = true
          this.$refs.searchItem.query()
        })
      }
    },
    // 调用接口前校验
    async checkActualAmountToYYU8() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_WriteOffRecordsNotSelected'))
        return false
      }
      const keys = []
      for (const row of rows) {
        if (row.syncExternalStatus === ChargeConstants.HM_YONGYOU_SYNC_SUCCESS.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_HasSync'))
          return false
        }
        if (this.oversea !== 0 || row.oversea) {
          this.$message.warning(this.$t('CargoMsg.Cargo_OverseaActualAmount'))
          return false
        }
        keys.push(row.uuid)
      }
      const result = await checkActualAmountToYYU8(keys).then(res => res.data)
      if (result) {
        if (result.msgType === 1) { // 国外销账数据，不可同步用友。
          this.$message.warning(this.$t('CargoMsg.Cargo_OverseaActualAmount'))
          return false
        }
        if (result.msgType === 2) { // 存在一个销账流水中，包含多个开票抬头。无法推送用友，请调整数据。
          this.$message.warning(this.$t('CargoMsg.Cargo_MultiInvoiceTitle'))
          return false
        }
        if (result.msgType === 3) { // 对应发票抬头没有对应用友的“凭证系统客商编码”
          this.$message.warning(this.$t('Clearing.InvoiceTitleNotSync', [result.msg]))
          return false
        }
      }
      return true
    }
  }
}
</script>
<style lang="scss">
  .queryWriteOff {
    .el-form-item-search {
      margin-right: 15px;
      .el-form-item__label {
        padding-right: 5px;
        font-size: 14px !important;
      }
      .el-form-item__content {
        .el-radio {
          margin-right: 3px;
          .el-radio__label {
            font-size: 13px !important;
            padding-left: 2px;
          }
        }
        .el-checkbox {
          .el-checkbox__label {
            font-size: 13px !important;
            padding-left: 2px;
          }
        }
        .el-date-editor {
          //.el-input__prefix {
          //  display: none;
          //}
        }
        .el-input {
          width: 110px;
        }
        .el-input__inner {
          padding-left: 20px !important;
          padding-right: 5px !important;
          width: 110px;
        }
      }
    }
  }
</style>
